import React from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import { LICENSE_STATUS_TABS } from '../utils/licenseConstants';
import useLicenseSx from '../hooks/useLicenseSx';

export default function LicenseStatusTabs({ value, onChange, counts = {} }) {
  const styles = useLicenseSx();

  return (
    <Box sx={styles.statusTabs}>
      <Tabs
        value={value}
        onChange={(_, nextValue) => onChange(nextValue)}
        variant="scrollable"
        scrollButtons="auto"
        allowScrollButtonsMobile
      >
        {LICENSE_STATUS_TABS.map((tab) => {
          const count = counts[tab.value] ?? 0;
          const isSelected = value === tab.value;

          return (
            <Tab
              key={tab.value}
              value={tab.value}
              sx={styles.statusTab}
              label={(
                <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center' }}>
                  {tab.label}
                  <Box
                    component="span"
                    sx={[
                      styles.statusTabCount,
                      isSelected && styles.statusTabCountSelected,
                    ]}
                  >
                    {count}
                  </Box>
                </Box>
              )}
            />
          );
        })}
      </Tabs>
    </Box>
  );
}
